import type { Translations } from './de'

const fr: Translations = {
  'language.flag': '🇫🇷',
  'language.name': 'Français',
  'navigation.home': 'Accueil',
  'navigation.language': 'Langue',
  'navigation.openMenu': 'Ouvrir le menu',
  'navigation.closeMenu': 'Fermer le menu',
  'navigation.skipToContent': 'Aller au contenu',
  'categories.sightseeing.name': 'À voir',
  'categories.sightseeing.heading': 'Les sites les plus populaires d’Augsbourg',
  'categories.sightseeing.lead': 'Du patrimoine mondial de l’UNESCO à la Fuggerei, Augsbourg a plus à offrir que vous ne le pensez.',
  'categories.events.name': 'Événements',
  'categories.events.heading': 'Tous les événements en un coup d’œil',
  'categories.events.lead': 'Concerts, marchés, visites guidées : découvrez ce qui se passe à Augsbourg cette semaine.',
  'categories.blog.name': 'Actualités',
  'categories.blog.heading': 'Nouvelles d’Augsbourg',
  'categories.blog.lead': 'Contexte, histoire de la ville et sujets d’actualité à lire et à partager.',
  'categories.emptyTitle': 'Rien pour le moment',
  'categories.emptyDescription': 'Cette rubrique ne contient encore aucune page. Revenez bientôt.',
  'home.title': 'Bienvenue à Augsbourg',
  'home.intro': 'Escapade urbaine, voyage d’affaires ou visite en famille : vous trouverez ici toutes les informations importantes pour votre séjour à Augsbourg.',
  'home.sightseeing.eyebrow': 'Ville du patrimoine mondial de l’UNESCO',
  'home.sightseeing.title': 'Découvrir les sites',
  'home.sightseeing.lead': 'Du patrimoine mondial de l’UNESCO à la Fuggerei, Augsbourg a plus à offrir que vous ne le pensez.',
  'home.sightseeing.action': 'Découvrir',
  'home.events.eyebrow': 'Que se passe-t-il à Augsbourg ?',
  'home.events.title': 'Trouver des événements',
  'home.events.lead': 'Ne manquez plus aucun concert, marché aux puces ou festival. Sur notre page des événements, vous êtes toujours bien informé.',
  'home.events.action': 'Tous les événements',
  'home.blog.eyebrow': 'Histoires de la ville',
  'home.blog.title': 'Nouveautés et curiosités',
  'home.blog.lead': 'Vous trouverez ici tout ce qu’il faut savoir sur Augsbourg, pour être bien informé pendant votre visite.',
  'home.blog.action': 'Vers le blog',
  'home.language.eyebrow': 'Augsbourg est internationale',
  'home.language.title': 'Passer à votre langue',
  'home.language.lead': 'Ce site est disponible en plusieurs langues. Souhaitez-vous changer de langue ?',
  'home.highlights.eyebrow': 'Sélectionné pour vous',
  'home.highlights.title': 'Nos recommandations',
  'home.highlights.lead': 'Pour bien commencer, nous avons réuni pour vous quelques temps forts d’Augsbourg. Bonne lecture !',
  'search.placeholder': 'Rechercher...',
  'search.clear': 'Effacer la recherche',
  'search.label': 'Rechercher des pages',
  'search.results': '{{count}} résultats pour « {{query}} »',
  'search.emptyTitle': 'Aucun résultat',
  'search.emptyDescription': 'Nous n’avons rien trouvé pour cette recherche. Essayez un autre terme.',
  'pagination.label': 'Pages',
  'pagination.previous': 'Page précédente',
  'pagination.next': 'Page suivante',
  'pagination.page': 'Page {{page}}',
  'pagination.summary': '{{start}}–{{end}} sur {{total}}',
  'page.back': 'Retour',
  'page.readMore': 'En savoir plus',
  'page.tableOfContents': 'Sur cette page',
  'page.openInGoogleMaps': 'Ouvrir dans Google Maps',
  'map.copyAddress': 'Copier l’adresse',
  'map.copied': 'Copié',
  'map.copyFailed': 'Copie impossible',
  'map.routeInGoogleMaps': 'Itinéraire dans Google Maps',
  'map.zoomIn': 'Zoom avant',
  'map.zoomOut': 'Zoom arrière',
  'map.showAll': 'Tout afficher',
  'attribution.toggle': 'Afficher ou masquer les sources',
  'map.gestures.windows': 'Utilisez Ctrl + molette pour zoomer sur la carte',
  'map.gestures.mac': 'Utilisez ⌘ + molette pour zoomer sur la carte',
  'map.gestures.mobile': 'Utilisez deux doigts pour déplacer la carte',
  'map.loading': 'Chargement de la carte …',
  'map.failed': 'La carte n’a pas pu être chargée.',
  'map.showPlace': 'Afficher {{name}} sur la carte',
  'map.marker': '{{name}}, {{icon}}',
  'map.numberedMarker': '{{number}}. {{name}}, {{icon}}',
  'map.route.walkingTime': 'environ {{duration}} à pied',
  'map.route.stops': '{{count}} étapes',
  'map.route.leg': '{{distance}} · environ {{duration}}',
  'mapIcons.landmark': 'Site touristique',
  'mapIcons.church': 'Église',
  'mapIcons.museum': 'Musée',
  'mapIcons.park': 'Parc et nature',
  'mapIcons.viewpoint': 'Point de vue',
  'mapIcons.cafe': 'Café',
  'mapIcons.bar': 'Bar',
  'mapIcons.restaurant': 'Restaurant',
  'mapIcons.shop': 'Shopping',
  'mapIcons.event': 'Lieu d’événements',
  'mapIcons.transport': 'Transports',
  'mapIcons.place': 'Lieu',
  'footer.imprint': 'Mentions légales',
  'footer.privacy': 'Politique de confidentialité',
  'footer.mediaLicense': 'Droits sur les images',
  'legal.bindingNote': 'Cette traduction est fournie à titre informatif uniquement. Seule la version allemande fait foi.',
  'imprint.provider.heading': 'Informations conformément au § 5 DDG',
  'imprint.contact.heading': 'Contact',
  'imprint.contact.email': 'E-mail',
  'imprint.responsible.heading': 'Responsable du contenu conformément au § 18, al. 2 MStV',
  'privacy.intro': 'Cette politique de confidentialité explique quelles données personnelles sont traitées lorsque tu visites ce site web.',
  'privacy.controller.heading': 'Responsable du traitement',
  'privacy.controller.text': 'Le responsable du traitement des données sur ce site web est :',
  'privacy.hosting.heading': 'Hébergement',
  'privacy.hosting.text': 'Ce site web est hébergé par un prestataire d\'hébergement externe établi en Allemagne. Les serveurs sont situés en Allemagne.',
  'privacy.serverLogs.heading': 'Fichiers journaux du serveur',
  'privacy.serverLogs.text': 'À chaque visite de ce site web, le serveur enregistre automatiquement les informations transmises par ton navigateur : adresse IP, date et heure de la requête, page consultée, volume de données transférées, URL de provenance, ainsi que navigateur et système d\'exploitation. Ces données sont nécessaires au fonctionnement sûr et stable du site (art. 6, par. 1, point f du RGPD) et sont supprimées au plus tard après 7 jours.',
  'privacy.analytics.heading': 'Mesure d’audience',
  'privacy.analytics.text': 'Pour savoir quelles pages sont lues, nous comptons nous-mêmes les pages vues, sans service externe et sans cookies. Lorsque tu ouvres une page, ton navigateur transmet uniquement son adresse à notre serveur. Pour chaque adresse, langue et jour, nous enregistrons seulement le nombre de pages vues, séparé entre navigateurs et programmes automatisés (robots d’indexation), que nous distinguons grâce à l’identifiant du navigateur (user agent). Ton adresse IP, l’identifiant de ton navigateur ou d’autres informations te concernant ne sont pas enregistrés à cette fin ; il est impossible d’identifier des visiteurs individuels. Si ton navigateur envoie le signal « Global Privacy Control » ou « Do Not Track », ta visite n’est pas comptée. Les chiffres sont supprimés au bout d’un an. La base juridique est l’art. 6, par. 1, point f du RGPD ; notre intérêt légitime est d’améliorer ce site.',
  'privacy.errorReports.heading': 'Rapports d\'erreur',
  'privacy.errorReports.text': 'Si une erreur technique survient lors du chargement d\'une page, un e-mail contenant des informations sur la requête échouée est automatiquement envoyé à l\'exploitant. Il peut contenir ton adresse IP, l\'adresse consultée et des informations sur ton navigateur. Les rapports d\'erreur servent uniquement à corriger les erreurs (art. 6, par. 1, point f du RGPD).',
  'privacy.cookies.heading': 'Cookies',
  'privacy.cookies.text': 'Ce site web utilise uniquement des cookies techniquement nécessaires, indispensables à ta session et à la protection contre les requêtes falsifiées (CSRF). Ils ne contiennent aucune donnée à des fins d\'analyse ou de publicité et sont supprimés à la fermeture de ton navigateur. La base juridique est le § 25, al. 2, n° 2 TDDDG en liaison avec l\'art. 6, par. 1, point f du RGPD ; aucun consentement n\'est requis. Aucun service externe d’analyse ou de suivi n’est utilisé ; la mesure d’audience décrite ci-dessus fonctionne sans cookies.',
  'privacy.rights.heading': 'Tes droits',
  'privacy.rights.text': 'Tu disposes des droits suivants :',
  'privacy.rights.access': 'l\'accès à tes données enregistrées (art. 15 RGPD)',
  'privacy.rights.rectification': 'la rectification (art. 16 RGPD)',
  'privacy.rights.erasure': 'l\'effacement (art. 17 RGPD)',
  'privacy.rights.restriction': 'la limitation du traitement (art. 18 RGPD)',
  'privacy.rights.portability': 'la portabilité des données (art. 20 RGPD)',
  'privacy.rights.objection': 'l\'opposition au traitement (art. 21 RGPD)',
  'privacy.rights.contact': 'Pour exercer ces droits, envoie simplement un e-mail à :',
  'privacy.complaint.heading': 'Droit de réclamation',
  'privacy.complaint.text': 'Tu as le droit d\'introduire une réclamation auprès d\'une autorité de contrôle de la protection des données. L\'autorité compétente est le Bayerisches Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach, Allemagne.',
  'privacy.updated': 'Dernière mise à jour : octobre 2026',
  'mediaLicense.intro': 'Toutes les photos, vidéos, documents et itinéraires de ce site appartiennent à Visit Augsburg. Tu peux les utiliser, les partager et les modifier sous la licence Creative Commons Attribution 4.0 International (CC BY 4.0) – y compris à des fins commerciales – à condition de nous citer comme source.',
  'mediaLicense.credit.heading': 'Comment nous citer',
  'mediaLicense.credit.text': 'Affiche cette mention de façon bien visible, directement à côté de l’image ou de la vidéo :',
  'mediaLicense.credit.link': 'Dans la mesure du possible, mets un lien vers la page d’où provient le média et vers la licence. Si tu as modifié un média, indique-le.',
  'mediaLicense.ai.heading': 'Assistants IA et moteurs de recherche',
  'mediaLicense.ai.text': 'Cela vaut aussi pour les chatbots, les assistants IA et les moteurs de recherche : quiconque affiche une image ou une vidéo de ce site affiche avec elle la mention « {{credit}} ». L’auteur, la mention et la licence figurent sous forme lisible par machine dans chaque fichier image (IPTC/XMP) et dans les données structurées (schema.org) de chaque page.',
  'mediaLicense.license.heading': 'Licence',
  'mediaLicense.license.text': 'Le texte de la licence Creative Commons s’applique :',
  'mediaLicense.license.link': 'CC BY 4.0 – Attribution 4.0 International',
  'mediaLicense.scope.heading': 'Ce que la licence ne couvre pas',
  'mediaLicense.scope.text': 'Les textes de ce site ne font pas partie de la licence. Les données cartographiques proviennent d’OpenStreetMap et sont disponibles sous la licence Open Database License (© contributeurs d’OpenStreetMap).',
  'mediaLicense.contact': 'Des questions sur l’utilisation ? Envoie un e-mail à :',
  'mediaLicense.updated': 'Dernière mise à jour : octobre 2026',
  'gallery.previous': 'Image précédente',
  'gallery.next': 'Image suivante',
  'gallery.showImage': 'Afficher {{title}}',
  'video.play': 'Lire {{title}}',
  'videoGallery.summaryOne': '1 vidéo · {{minutes}} min',
  'videoGallery.summaryOther': '{{count}} vidéos · {{minutes}} min',
  'tags.unesco_heritage': 'Patrimoine UNESCO',
  'tags.landmark': 'Emblème',
  'tags.church_monastery': 'Église & monastère',
  'tags.museum_culture': 'Musée & culture',
  'tags.park_nature': 'Parc & nature',
  'tags.viewpoint': 'Point de vue',
  'tags.accessible': 'Accessible',
  'tags.free': 'Gratuit',
  'tags.family_friendly': 'En famille',
  'tags.concert': 'Concert',
  'tags.market': 'Marché',
  'tags.guided_tour': 'Visite guidée',
  'tags.festival': 'Festival',
  'tags.exhibition': 'Exposition',
  'tags.sports': 'Sport',
  'tags.open_air': 'En plein air',
  'tags.city_history': 'Histoire de la ville',
  'tags.tips_tricks': 'Trucs & astuces',
  'tags.interview': 'Interview',
  'tags.food_drink': 'Gastronomie',
  'tags.seasonal': 'Saisonnier',
  'tags.behind_the_scenes': 'Dans les coulisses',
  'tags.event_recap': 'Retour sur l’événement',
}

export default fr
